import React, { useState } from 'react';
import { IoEye, IoEyeOff } from 'react-icons/io5';
import { 
  Input,
  InputWrapper,
  FormGroup
} from '../UI/Inputs';
import { 
  Button,
  IconButton
} from '../UI/Buttons';
import { 
  Label,
  ErrorText
} from '../UI/Typography';
import { FlexContainer } from '../UI/Containers';

const LoginTab = ({ onLogin, isLoading, error }) => {
  const [username, setUsername] = useState(''); 
  const [password, setPassword] = useState('');
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin({
      email: username.trim(),
      password: password.trim()
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <FormGroup> 
        <Label htmlFor="username">Email</Label>
        <Input 
          type="text"
          id="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Enter your email"
          required
          disabled={isLoading}
          autoComplete="email"
        />
      </FormGroup>

      <FormGroup> 
        <Label htmlFor="password">Password</Label> 
        <InputWrapper>
          <Input
            type={isPasswordVisible ? 'text' : 'password'}
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            required
            disabled={isLoading}
            autoComplete="current-password"
            hasIcon
          />
          <IconButton
            type="button"
            position="absolute"
            onClick={togglePasswordVisibility}
            title={isPasswordVisible ? "Hide password" : "Show password"}
            disabled={isLoading}
            aria-label={isPasswordVisible ? "Hide password" : "Show password"}
          >
            {isPasswordVisible ? <IoEyeOff size={20} /> : <IoEye size={20} />}
          </IconButton>
        </InputWrapper>
      </FormGroup>

      <ErrorText>
        {error || ''}
      </ErrorText> 

      <FlexContainer justify="center" style={{ marginTop: '0.5rem' }}> 
        <Button 
          type="submit" 
          disabled={isLoading} 
          style={{ width: '100%' }}
          aria-label={isLoading ? 'Logging in...' : 'Login'}
        > 
          {isLoading ? 'Logging in...' : 'Login'}
        </Button>
      </FlexContainer>
    </form>
  );
};

export default LoginTab;